import { render, staticRenderFns } from "./TrailersPage.vue?vue&type=template&id=0b52fb53"
import script from "./TrailersPage.vue?vue&type=script&lang=js"
export * from "./TrailersPage.vue?vue&type=script&lang=js"
import style0 from "./TrailersPage.vue?vue&type=style&index=0&id=0b52fb53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports